<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
          <i class="fas fa-user-alt"></i>
          プロフィール
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">Main</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">プロフィール</a>
          </li>
      </ul>
    </div>
    <b-card>
      <!-- <div slot="header">
        <strong>Profile</strong>
        <small class="pull-right">{{model.created_at | datetime}}</small>
      </div> -->
      <b-row>
        <b-col>
          <div class="title mr-auto mb7">
            プロフィール
          </div>
        </b-col>
        <b-col>
          <span class="font_13 float-right">
            {{model.created_at | datetime}}@{{ model.last_addr }}
          </span>
        </b-col>
        <!-- <div class="d-flex flex-wrap align-items-center">
          <div class="title mr-auto mb7">
              Profile
          </div>
          <div class="mb7">
              <span class="font_13">2022.06.23 19:28:13@1.222.30.44</span>
          </div>
        </div> -->
      </b-row>
      <hr>
      <b-row>
        <!-- <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="Allow_login">
                グループ名
            </label>
        </div>
        <div class="col-xl-4 col-md-12  d-flex align-self-center">
            ヒューマンバリュー
        </div> -->
        <b-col md="3" v-if="model.group" class="col-form-label">
          会社名
        </b-col>
        <b-col md="3">
          <b-input type="text" v-model="model.group.groupname" plaintext></b-input>
        </b-col>
        <b-col md="2" v-if="model.group" class="col-form-label">
          サービス
        </b-col>
        <b-col>
          <b-badge variant="success" class="font-weight-bold">
          {{model.group.service}}
          </b-badge>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3" v-if="model.group" class="col-form-label">
          グループメール
        </b-col>
        <b-col md="3" v-if="model.group">
          <b-input type="text" v-model="model.group.email" plaintext></b-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3" v-if="model.group" class="col-form-label">
          住所
        </b-col>
        <b-col>
          <b-input type="text" v-model="model.group.address" plaintext></b-input>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="3" class="col-form-label">
          ユーザ名
        </b-col>
        <b-col md="3">
          <b-input type="text" v-model="model.username" plaintext></b-input>
        </b-col>
        <b-col md="2" class="col-form-label">
          ニックネーム
        </b-col>
        <b-col md="3">
          <b-input type="text" v-model="model.nickname" plaintext></b-input>
        </b-col>
      </b-row>
      <b-row v-show="add || !lock">
        <b-col md="3" class="col-form-label">
          パスワード
        </b-col>
        <b-col md="3">
          <b-input type="password" v-model="pass.old" :plaintext="lock"></b-input>
        </b-col>
        <b-col md="2" class="col-form-label">
          {{add ? 'User' : 'Change'}} パスワード(*)
        </b-col>
        <b-col>
          <b-form-group>
            <b-form-input type="password" v-model="pass.new" :plaintext="lock"></b-form-input>
            <b-badge v-if="pass.new"  :variant="password_policy('number') ? 'success' : 'danger'"> ナンバー </b-badge>
            <b-badge v-if="pass.new"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> 上限文字 </b-badge>
            <b-badge v-if="pass.new"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> 下限文字 </b-badge>
            <b-badge v-if="pass.new"  :variant="password_policy('spacial') ? 'success' : 'danger'"> 特殊文字 </b-badge>
            <b-badge v-if="pass.new"  :variant="password_policy('length') ? 'success' : 'danger'">
              最小長さ : {{password_meter.min_length}}
            </b-badge>
          </b-form-group>
        </b-col>

      </b-row>
      <b-row v-show="add || !lock">
        <b-col md="6">
        </b-col>
        <b-col md="6" v-if="pass.new">
          <b-form-group class="text-primary">
            <label for="ph_pass_repeat">パスワード再入力</label>
            <b-input type="password" v-model="pass.repeat" :plaintext="lock"></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="add || !lock">
        <b-col md="3" class="col-form-label">
          <span v-if="this.otp_model.otp_key == (undefined, '', null) || !this.otp_model.otp_key" for="ph_is_otp_use">OTPアクティブ</span>
          <span v-else for="ph_is_otp_use">OTP解除</span>
        </b-col>
        <b-col md="3">
          <b-button v-if="this.otp_model.otp_key == (undefined, '', null) || !this.otp_model.otp_key" block @click="genOtp()" :variant="'primary'" :disabled="lock"> OTP登録 </b-button>
          <b-button v-else block @click="removeOTP()" variant="danger"> OTP解除 </b-button>
        </b-col>
      </b-row>
      <!-- <b-row v-show="toggleOtp" class="text-center"> -->
      <b-row v-show="toggleOtp && qrcode && !lock">
        <b-col md="3"></b-col>
        <b-col md="3" class="text-center">
          <b-form-group>
            <img v-if="qrcode" :src="qrcode">
          </b-form-group>
        </b-col>
      </b-row>
    <b-row v-show="toggleOtp && qrcode && !lock">
      <b-col md="3" class="col-form-label">
        OTPコード
      </b-col>
      <b-col md="3">

        <b-form-input type="text" v-model="model.otp_code" :plaintext="lock"></b-form-input>
      </b-col>
      <b-col md="3">
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col md="3" class="col-form-label">
        国
      </b-col>
      <b-col md="3">
        <v-select :readonly="true" :disabled="lock" label="name" v-model="region.country" :options="codes.country" ></v-select>
      </b-col>
      <b-col md="2" class="col-form-label">
        タイムゾーン <strong class="text-danger">*</strong>
      </b-col>
      <b-col md="3">
        <v-select :readonly="true" :disabled="lock" label="name" v-model="region.timezone" :options="codes.timezone" ></v-select>
      </b-col>
    </b-row>
    <hr>
      <template v-if="lock">
        <template>
          <b-button size="sm" variant="primary" @click="edit" class="btn-add"> 変更 </b-button>
        </template>
      </template>
      <template v-else>
        <b-button class="btn-add" size="sm" variant="success" @click="save"> 保存 </b-button>
        <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> キャンセル </b-button>
      </template>
    </b-card>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
